import * as React from "react";

import "./details.scss";

import {is3rdPartyWorkflow} from "@Common/logic/item/is-3rd-party";
import {isMasterVariation}  from "@Common/logic/item/is-master-variation";
import {isPickPack}         from "@Common/logic/item/is-pick-pack";
import {cs}                 from "@Common/react/chain-services";
import {chain}              from "@Common/utils/fs";
import {entries,
        isNotEmpty,
        oMapToArr}          from "@Common/utils/objects";
import {createString}       from "@Common/utils/strings";

import {getDistributionLevelLabel} from "../get-distribution-level-label";
import { itemCreditLines } from "@Common/logic/cart/item-credit-lines";

export const Details = ({item, company}) => cs(
    ({}) => (
        <div className="details details-1xw">
            {blocks({company}).filter((b) => !b.condition || b.condition?.(item)).map((block, i) => {
                const lines = block.lines({item}).flat().filter(v => v);

                return !!lines.length && (
                    <div className="block" key={i}>
                        <div className="label" xd-qa-type="label" xd-qa-name={`${block.label}`}>
                            {block.label}
                        </div>
                        <div className="value">
                            {lines.map((line, i) => (
                                <div className="line" key={i} xd-qa-type="label" xd-qa-name={`${line.trim()}`}>
                                    {(!!(item?.metaData?.template?.isNDM) && typeof line === 'string') ? line.replace(/Standard Mailing/g, 'Neighborhood Direct Mail') : line}
                                </div>
                            ))}
                        </div>
                    </div>
                );
            })}
        </div>
    ),
);

const blocks = ({company}) => [
    {
        label: "Options",
        condition: (item) => !isPickPack(item) && !is3rdPartyWorkflow(item) &&
            (!company?.prefs?.xpressoKitOptionsActive || !item?.components?.length),
        lines: ({item}) => [
            item.selections.options.find((o) => o.dev_key === "paper_type")?.name,
            item.selections.options.find((o) => o.group === "Finishing")?.subGroup,
            item.selections.options.filter((o) => o.group === "lineItem").map((o) => o.desc),
            item.selections.options.find((o) => o.dev_key === "pdf_download")?.name,
            item.selections.options.filter((o) => o.group === "YARD SIGN OPTIONS").map((o) => o.name),
        ],
    },
    {
        label: "Options", // PickPack
        condition: (item) => is3rdPartyWorkflow(item) || isPickPack(item) || isMasterVariation(item),
        lines: ({item}) => (
            chain(
                item.selections?.options?.find((o) => o.dev_key === "pick_pack_options")?.name,
                (optionJSON) => (optionJSON && JSON.parse(optionJSON)) ?? {},
                (pickPackOptions) => isMasterVariation(item) ? (
                    pickPackOptions?.filter((o) => o.type === "options")?.map(({uiLabel, uiValue}) => (
                        uiLabel + ": " + uiValue
                    ))
                ) : (
                    entries(pickPackOptions).map(([key, value]) => (
                        key + ": " + value
                    ))
                )
            )
        ),
    },
    {
        label: "Mailing Details",
        condition: (item) => item.selections.distributionType === "mailing",
        lines: ({item}) => [
            getDistributionLevelLabel(item),
            item.selections.mailingListIds?.map((ml, i) => (
                (i===0 ? "Address List - " : createString(" ", 32)) +
                ml.name
            )),
        ],
    },
    {
        label: "Pickup Details",
        condition: (item) => item.selections.distributionType === "pickup",
        lines: ({item}) => [
            "Pickup Location: " + item.pickupAddress.address1 + ", " + item.pickupAddress.address2,
            "Keep an eye out for a notification email confirming that your order",
            "is ready for pickup on or after " + item.shipDate,
        ],
    },
    company?.prefs?.xpressoKitOptionsActive && {
        label: "Kit Options",
        condition: (item) => isNotEmpty(item?.components),
        lines: ({item}) => {
            return oMapToArr(item?.components, ((component) => (
                chain(
                    component?.selections?.options,
                    (option) => ([
                        ...[!isPickPack(component) && !is3rdPartyWorkflow(component) && option?.find((o) => o?.dev_key === "paper_type")?.name] ?? [],
                        ...[option?.find((o) => o?.group === "Finishing")?.subGroup] ?? [],
                        ...option?.filter((o) => o?.group === "lineItem").map((o) => o.desc) ?? [],
                        ...[option?.find((o) => o?.dev_key === "pdf_download")?.name] ?? [],
                        ...option?.filter((o) => o?.group === "YARD SIGN OPTIONS").map((o) => o.name) ?? [],
                        ...chain(
                            option?.find((o) => o?.dev_key === "pick_pack_options")?.name,
                            (pick_pack_option) => (pick_pack_option && JSON.parse(pick_pack_option)) ?? {},
                            (pick_pack_option) => entries(pick_pack_option).map(([key, value]) => (
                                key + ": " + value
                            ))
                        ),
                    ]),
                )
                ).map((v) => v).filter(Boolean)
            ));
        }
    }
].filter(Boolean);

